import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { DemoModeService } from '../demo/demo-mode.service';

/**
 * Guards the root `/` (the marketing landing). Signed-out visitors see the
 * landing at the base URL; authenticated users (and demo sessions) are sent
 * straight to their app dashboard instead.
 */
export const redirectAuthedToHomeGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const demo = inject(DemoModeService);

  return auth.isLoading$.pipe(
    filter((loading) => !loading),
    take(1),
    switchMap(() => auth.isAuthenticated$),
    take(1),
    map((isAuthenticated) =>
      isAuthenticated || demo.active ? router.parseUrl('/home') : true,
    ),
  );
};
